import React, { useState, useEffect, useRef } from 'react';
import  { useNavigate, useSearchParams } from 'react-router-dom'
import { api } from '../utils/endpoint.js'


import ThaivivatLogo from '../components/ThaivivatLogo.js'
import imgBanner from '../images/tracking/img_tracking.svg'
import iconWarningAlert from '../images/alert/ic_warning.svg'
import iconCloseAlert from '../images/alert/ic_close.svg'
import TrackingDetailCompnent from '../components/TrackingDetailComponent.js'

function TrackPage() {

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [ isShowAlert, setIsShowAlert ] = useState(false)
  const [ alertMessage, setAlertMessage ] = useState('กรุณาระบุเลขที่รายการ')
  
  const [ isShowDetail, setIsShowDetail ] = useState(false)
  const [ referenceNo, setReferenceNo ] = useState('')
  const [ referenceTrackNo, setReferenceTrackNo ] = useState('')

  const [ isShowAlertTop, setIsShowAlertTop ] = useState(false)
  const [ alertTextTop, setAlertTextTop ] = useState('')

  useEffect(() => {
    window.scrollTo(0, 0)
    setIsShowDetail(false)
  }, [referenceNo])


  useEffect(() => {
    window.scrollTo(0, 0)
    let ref_no = searchParams.get("ref_no")
    if (ref_no) {
      setReferenceNo(ref_no)
      callApiGetTracking( ref_no, false )
    }
  }, [])


  function validateNumber( event ){
    if (!/[0-9]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) ) {
      return false
    }
    return true
  }


  function onChangeReferenceNo( event, setterInput ){
    if (!validateNumber(event)) {
      event.preventDefault();
    }
    else if( event.nativeEvent.data === undefined){
      //Clear
      setterInput("")
    }
    else{
      //Set Value
      setterInput(event.target.value)
    }
  }


  async function callApiGetTracking( ref_no, isMobile ) {
    await fetch(api.nonemcs.tracking(`ref_no=${ref_no}`))
    .then( async (response) => {
      if(response.ok){
        return response.json();         
      }
      throw ({status:response.status, body: await response.json()});
    }).then(data => onSuccessCallApiGet(data, isMobile), (error) => {
      if (error) {
        onFailCallApiGet(error )
      }
    });
  }
  async function onSuccessCallApiGet( data, isMobile ){
    if(data && data.transaction_id) {  
      setReferenceTrackNo(data.transaction_id)
      setAlertMessage('')
      if(isMobile){
        //mobile + tablet
        gotoTrackDetail(data.transaction_id)
      }
      else{
        //Desktop
        showTrackDetail(data.transaction_id)

      }
    } else {
      // fail
      setReferenceTrackNo('')
      setAlertMessage('ไม่พบเลขที่รายการ')
      showAlert()
      setIsShowDetail(false)
    }

  }
  async function onFailCallApiGet( data ){
    if (data && data?.status >= 400) {
      const statusCode = data.status.toString()
      if(statusCode[0] == '4'){
        switch (data.status) {
          case 400:
            setAlertTextTop(data.body.message)
            showAlertTop()
            break;
          case 404:
            setReferenceTrackNo('')
            setAlertMessage('ไม่พบเลขที่รายการ')
            showAlert()
            setIsShowDetail(false)
            break;
          default:
            setAlertTextTop('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
            showAlertTop()
        }
      } else if(statusCode[0] == '5'){
        setAlertTextTop(data.body.message)
        showAlertTop()
      }
    }else{
      setAlertTextTop("เกิดข้อผิดพลาด กรุณาติดต่อฝ่ายลูกค้าสัมพันธ์ โทร. 1231 กด 4")
      showAlertTop()
    }

  }



  function gotoTrackDetail(referenceNo){
    navigate("/track/detail", { replace: true, state: { referenceNo: referenceNo } , })
  }

  function showTrackDetail(referenceNo){
    setIsShowDetail(true)
  }

  async function submit(  isMobile ){   
    if (referenceNo != '') {
      await callApiGetTracking( referenceNo, isMobile )
    } else {
      setAlertMessage('กรุณาระบุเลขที่รายการ')
      setIsShowAlert(true)
    }
 
  }



  const timer = useRef(null);
  const [ counter, setCounter ] = useState(1);
  function showAlert(){
    clearIntervalAlert()
    setIsShowAlert(true)
    setCounter(1)
    setAlertTimer()
  }
  
  function showAlertTop(){
    clearIntervalAlert()
    setIsShowAlertTop(true)
    setCounter(1)
    setAlertTimer()
  }
  function closeAlert(){
    clearIntervalAlert()
 
  }
  function closeAlertTop(){
    clearIntervalAlertTop()
 
  }
  function setAlertTimer(){
    timer.current = setInterval(() => {
      setCounter((v) => v + 1)
    }, 1000);
    return () => clearTimeout(timer.current);
  }
  useEffect(() => {
    if (counter >= 5){
      clearIntervalAlert()
      clearIntervalAlertTop()
    }
  }, [counter]);

  function clearIntervalAlert(){
    clearInterval(timer.current);
    setIsShowAlert(false);
    setCounter(1)
  }
  function clearIntervalAlertTop(){
    clearInterval(timer.current);
    setIsShowAlertTop(false);
    setCounter(1)
  }

  return (
  <div className="w-full  bg-white font-prompt ">
      <div className="flex flex-wrap w-full bg-white font-prompt">

          <div className={((isShowAlertTop)? ' fixed ' : ' hidden ' )+ 'bg-[#252525]  text-white  top-[9%]  flex inset-x-0 mx-auto shadow-alert  w-fit h-[40px] py-[10px] px-[12px] mb-[40px] rounded-lg z-30'}>
            <img src={iconWarningAlert} alt="icon-warning-alert" className='w-[16px] h-[16px] mr-[8px] my-auto' />
            <span data-testid='toast-description-text' className='text-sm not-italic font-normal  my-auto' >{alertTextTop}</span>
            <button onClick={(e) => { closeAlertTop() }}><img src={iconCloseAlert} alt="icon-close-alert " className='w-[16px] h-[16px] ml-[8px] my-auto' /></button>
          </div>

          <div className={' flex w-full min-h-screen  h-full justify-center px-4 md:px-0 bg-green-500 items-center '+((isShowDetail)? ' lg:w-1/2 ' : '')}>

            <div className='md:flex flex-wrap w-full '>
              
              <div className='flex w-full justify-center mt-6 lg:mt-0'>
                
                <div className=' w-[130px] h-[40px]' >
                  <ThaivivatLogo></ThaivivatLogo>
                </div>

              </div>

              <div className='flex flex-wrap w-full mt-6 justify-center '>
                <div className='flex-wrap w-full md:w-[460px] py-6 px-4 md:p-8 bg-white rounded-lg'>
                  <div className='flex w-full justify-center'>
                    <img src={imgBanner} alt="banner-tracking" className='flex w-[160px] h-[160px] md:w-[280px] md:h-[280px]' />
                  </div>
                  <div className='flex-wrap w-full mt-6'>
                    <span className='flex w-full text-xl lg:text-2xl font-medium leading-7 lg:leading-8'>ติดตาม<br/>ผลการเรียกค่าสินไหมทดแทน</span>
                    <span className='flex w-full mt-4 text-lg font-base lg:font-normal leading-5 lg:leading-6 text-grey-600'>กรุณาระบุเลขที่รายการของคุณ</span>

                    <div className='flex flex-wrap lg:flex-nowrap w-full mt-6 '>
                      <div className='grow-0 lg:grow flex flex-wrap w-full pr-4'>
                        <input value={referenceNo} onChange={ (e)=> { onChangeReferenceNo(e, setReferenceNo) }} type={'search'} className={' w-full font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400 ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ระบุ' />
                        {
                          isShowAlert ?

                          <span className='w-full flex flex-wrap text-[12px] mt-[4px] text-red-500'>{ alertMessage}</span>
                          :
                          null
                        }
                      </div> 
                      <div className='flex lg:hidden grow-0 lg:flex-none w-full lg:w-fit mt-4 lg:mt-0'>
                        <button 
                            onClick={(e)=>{submit(true)}}
                            className={'w-full lg:px-4 text-base leading-6 h-[48px] md:h-12 font-medium rounded-lg border-radius-other  '+ ( (false)? ' bg-grey-600 text-white ' : ' bg-green-500 text-white ')}>
                              เช็กสถานะ
                        </button>
                      </div> 
                      <div className='hidden lg:flex grow-0 lg:flex-none  w-full lg:w-fit mt-4 lg:mt-0'>
                        <button 
                            onClick={(e)=>{submit(false)}}
                            className={'w-[108px] lg:px-4 text-base leading-6 h-[48px] md:h-12 font-medium rounded-lg border-radius-other  '+ ( (false)? ' bg-grey-600 text-white ' : ' bg-green-500 text-white ')}>
                              เช็กสถานะ
                        </button>
                      </div> 
                    </div>
                  </div>
                </div>  

              </div>
            </div>
          </div>

          <div className={'hidden  flex-wrap w-full md:w-1/2 h-screen   overflow-y-auto'+ ((isShowDetail)? ' lg:flex ' : '' )}>

            <TrackingDetailCompnent referenceNo={referenceTrackNo} />

          </div>
      </div>
  </div>
  )
}

export default TrackPage;